//成功加载数据的ajax
import { doAjax } from './tools';

const defaultOpt = {
    page: false, //是否设置pageInfo，默认为不设置
};

export default async function LoadAjax(url, param, options) {

    let opt = Object.assign({}, defaultOpt, options);

    return new Promise((resolve, reject) => {
        var result = doAjax(url, param ? param : null, this, options);
        result.then((result) => {
            if (!result) {
                reject(new Error("服务器发生错误"));
                return;
            };
            let { data, data: { code, msg, pageIndex, pageSize, total } } = result;
            if (code == 200) {

                let result = null;
                let pageInfo = {
                    total,
                    pageSize,
                    pageIndex
                };
                if (data.hasOwnProperty('val')) {
                    result = data.val;
                } else if (data.hasOwnProperty('list')) {
                    result = data.list;
                };

                if (opt.page == true) {
                    this.pageInfo.total = (!!total ? total : 0);
                };
                if (this.loading) {//关闭loading
                    this.loading = false;
                }
                resolve({ data: result, pageInfo });

            } else {
                if (this.loading) {//关闭loading
                    this.loading = false;
                }
                this.$message.error(msg);
            }
        })
            .catch((error) => {
                if (this.loading) {   //关闭loading
                    this.loading = false;
                }
                reject(error);
            });
        ;
    });

};


